import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'prgov-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
})
export class AlertsComponent implements OnInit {
  @Input() type = 'info';
  @Input() slim = false;
  @Input('request') request;
  @Input() size = '';
  icon = 'info';
  constructor() {}

  ngOnInit() {
    switch (this.type) {
      case 'warning':
        this.icon = 'warning';
        break;
      case 'danger':
        this.icon = 'error';
        break;
      case 'success':
        this.icon = 'done';
        break;
      default:
        this.icon = 'info';
    }
  }

  getAlertCss() {
    return this.slim
      ? 'alert-display alert alert-' + this.type + ' slim'
      : 'alert-display alert alert-' + this.type + ' shadow-sm';
  }
}
